<template>
  <div class="contact-details">
    <p v-if="notification.statusId < 3">
      Please check that the correct people have been identified as the relevant
      and required Contacts. If you need to make corrections, please return to
      the Contacts page.
    </p>
    <hr class="border-dark" />
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">Landowner</h5>
    </b-form-row>
    <template v-if="contacts.landownerContact">
    <b-row>
      <b-col cols="12" md="8">
         <ContactDetails
            :contact="contacts.landownerContact"
            :disableRemove="true"
            :isSummaryPage="true"
          />
        <DetailRow
          label="Ownership of lands in Maine"
          :value="getAcresClass(notification.ownershipAcresClassId)"
        />
        <DetailRow
          label="Ownership Type"
          :value="getOwnershipType(notification.ownershipTypeId)"
        />
      </b-col>
      <b-col v-if="showConfidentiality" cols="12" md="4" class="mt-2 mt-md-0">
        <strong>The contact information for this landowner is designated by law as confidential.  [12 M.R.S. §8883-B (8)]  If this Forest Operations Notifications is shared with others, the landowner contact information (address, email, phone number) must be redacted to comply with state law.</strong>
      </b-col>
    </b-row>
    </template>
    <span v-else>None Indicated</span>
    <hr class="border-dark" />
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Designated Agent
      </h5>
    </b-form-row>
    <ContactDetails
      v-if="contacts.designatedAgentContact"
      :contact="contacts.designatedAgentContact"
      :disableRemove="true"
      :isSummaryPage="true"
    />
    <span v-else>None Indicated</span>
    <hr class="border-dark" />
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Harvester/Operator
      </h5>
    </b-form-row>
    <ContactDetails
      v-if="contacts.operatorContact"
      :contact="contacts.operatorContact"
      :disableRemove="true"
      :isSummaryPage="true"
    />
    <span v-else>None Indicated</span>
    <hr class="border-dark" />
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Licensed Forester
      </h5>
    </b-form-row>
    <template v-if="contacts.licensedForesterContact">
      <ContactDetails
        :contact="contacts.licensedForesterContact"
        :disableRemove="true"
        :isSummaryPage="true"
      />
      <DetailRow
        label="License Number"
        :value="contacts.licensedForesterContact.licensedForesterId"
      />
      <a
        :href="links.licensedForesterSearch"
        target="_blank"
        rel="noopener noreferrer"
        style="font-size: 1rem;"
      >
        License Status Search
      </a>
    </template>
    <span v-else>None Indicated</span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';
import ContactDetails from '@/components/account/ContactDetails.vue';
import DetailRow from '@/components/DetailRow.vue';

export default {
  name: 'FONContactDetails',
  components: {
    ContactDetails,
    DetailRow,
  },
  created() {
    this.$store.dispatch(
      `${LookupModules.OWNERSHIP_TYPES.namespace}/fetchOptions`,
    );
    this.$store.dispatch(
      `${LookupModules.ACRES_CLASSES.namespace}/fetchOptions`,
    );
  },
  computed: {
    contacts() {
      if (this.active || this.closed) {
        return {
          landownerContact:
            this.notification.landownerUser
            || this.notification.landownerContact,
          designatedAgentContact:
            this.notification.designatedAgentUser
            || this.notification.designatedAgentContact,
          operatorContact:
            this.notification.operatorUser
            || this.notification.operatorContact,
          licensedForesterContact:
            this.notification.licensedForesterUser
            || this.notification.licensedForesterContact,
        };
      }
      return {
        landownerContact: this.notification.landownerUser,
        designatedAgentContact: this.notification.designatedAgentUser,
        operatorContact: this.notification.operatorUser,
        licensedForesterContact: this.notification.licensedForesterUser,
      };
    },
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapGetters('Notification', [
      'draft',
      'pendingCertification',
      'active',
      'closed',
    ]),
    ...mapGetters(LookupModules.OWNERSHIP_TYPES.namespace, {
      getOwnershipType: 'getName',
    }),
    ...mapGetters(LookupModules.ACRES_CLASSES.namespace, {
      getAcresClass: 'getName',
    }),
    ...mapGetters('User', ['mfsUser']),
    showConfidentiality() {
      const ownershipAcresClassIds = [1, 2, 5];

      return ownershipAcresClassIds.includes(
        this.notification.ownershipAcresClassId,
      );
    },
  },
};
</script>
